<template>
  <div class="sale_ranking" id="sale_ranking">
    <div class="tab">
      <div v-for="(title, index) in tabTitle" :key="index">
        <div
          @click="changeSelect(index)"
          :style="{ marginRight: index == 1 ? '0' : '20px' }"
          class="tab-item-title"
          :class="{ 'tab-current': cur == index }"
        >{{ title }}</div>
      </div>
    </div>
    <!-- 线条 -->
    <div class="tab-cursor" :style="{ left: left }"></div>
    <div class="ranking-container">
      <div
        style="display: flex;flex-direction: row;align-items: center;justify-content: space-between"
      >
        <div class="ranking-date">
          {{
            cur == "0"
              ? "2021/12/01~" + moment().format("YYYY/MM/DD")
              : startTime +
              "~" +
              endTime
          }}
        </div>
        <div class="ranking-tip">
          <div style="width: 6px;height: 6px;background: #000000;opacity: 0.79;border-radius: 50%"></div>仅限订单实收款
        </div>
      </div>
      <div class="podium">
        <div class="second-rank">
          <div class="second-head">
            <img
              class="head-img"
              :src="
                second
                  ? second.headImgUrl != null && second.headImgUrl != undefined && second.headImgUrl != '' && second.headImgUrl != 'null' ? second.headImgUrl : 'https://imgs.youchalian.com/1639041618686.png'
                  : 'https://imgs.youchalian.com/1639041618686.png'
              "
            />
          </div>
          <div class="top-name" style="height:20px">{{ second ? second.userName : "暂无" }}</div>
          <div class="top-rank">第二名</div>
          <div class="top-price" v-if="second">￥{{ second ? toFixed(second.moneyTotal, 2) : "" }}</div>
        </div>
        <div class="first-rank">
          <div class="first-head">
            <img
              class="head-img"
              :src="
                first
                  ? first.headImgUrl && first.headImgUrl != undefined && first.headImgUrl != '' && first.headImgUrl != 'null' ? first.headImgUrl : 'https://imgs.youchalian.com/1639041618686.png'
                  : 'https://imgs.youchalian.com/1639041618686.png'
              "
            />
          </div>
          <div class="top-name" style="height:20px">{{ first ? first.userName : "暂无" }}</div>
          <div class="top-rank">第一名</div>
          <div class="top-price" v-if="first">￥{{ first ? toFixed(first.moneyTotal, 2) : "" }}</div>
        </div>
        <div class="third-rank">
          <div class="third-head">
            <img
              class="head-img"
              :src="
                third
                  ? third.headImgUrl && third.headImgUrl != undefined && third.headImgUrl != '' && third.headImgUrl != 'null' ? third.headImgUrl : 'https://imgs.youchalian.com/1639041618686.png'
                  : 'https://imgs.youchalian.com/1639041618686.png'
              "
            />
          </div>
          <div class="top-name" style="height:20px">{{ third ? third.userName : "暂无" }}</div>
          <div class="top-rank">第三名</div>
          <div class="top-price" v-if="third">￥{{ third ? toFixed(third.moneyTotal, 2) : "" }}</div>
        </div>
      </div>
      <div class="my-info">
        <img style="height: 40px;width: 40px;border-radius: 50%" :src="myMarket.headImgUrl" />
        <div style="display: flex;flex-direction: column;margin-left: 6px">
          <div class="my-name">{{ myMarket.userName }}</div>
          <div
            class="my-rank"
          >我的排名：{{ myMarket.rank == null ? "未上榜" : myMarket.rank == 9999 ? '直营店不参与排行' : myMarket.rank }}</div>
          <div
            class="my-disparity"
            v-if="myMarket.rank != '1' && myMarket.rank != 1"
          >距离上一名只差¥{{ toFixed(myMarket.differenceMoney, 2) }}</div>
        </div>
        <div class="my-sale">￥{{ toFixed(myMarket.moneyTotal, 2) }}</div>
      </div>
      <div class="rank-list" :style="rankList.length > 0 ? '' : 'flex:1;height:100%'">
        <template v-if="rankList.length > 0">
          <div v-for="(item, index) in rankList" :key="index">
            <div class="rank-item">
              <div class="rank-item-rank">{{ index + 4 }}</div>
              <img
                :src="item.headImgUrl?item.headImgUrl:'https://imgs.youchalian.com/1639041618686.png'"
                style="width: 44px;height: 44px;border-radius: 50%;margin-left: 16px"
              />
              <div class="rank-item-name">{{ item.userName }}</div>
              <div class="rank-item-sale">￥{{ toFixed(item.moneyTotal, 2) }}</div>
            </div>
            <div class="rank-divider" v-if="index != rankList.length - 1"></div>
          </div>
        </template>
        <template v-if="rankList.length === 0">
          <div
            style="width:100%;height:100%;display: flex;align-items: center;justify-content: center;flex:1;flex-direction: column;"
          >
            <van-empty description="暂无人员上榜" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPost } from "@/api/common";
import moment from "moment";
import { Dialog } from "vant";
export default {
  data() {
    return {
      startTime: "",
      endTime: "",
      cur: "", //默认选中第一个tab
      tabTitle: ["总销售额排行榜", "本周销售额排行榜"],
      shopId: this.$route.query.shopId,
      left: "0px",
      myMarket: {},
      first: {},
      second: {},
      third: {},
      rankList: []
    };
  },
  watch: {
    cur() {
      setTimeout(() => {
        this.changeLine();
      }, 100);
    }
  },
  created() {
    this.cur = "0";
    this.getTime();
    this.getRank();
  },
  methods: {
    changeSelect(index) {
      if (index != null && index != undefined) {
        this.cur = index;
      }
      this.getRank();
    },
    changeLine() {
      let current = document.querySelector(".tab-current");
      let line = document.querySelector(".tab-cursor");
      let currentRect = current.getBoundingClientRect();
      let lineRect = line.getBoundingClientRect();
      this.left =
        (currentRect.width - lineRect.width) / 2 + currentRect.left + "px";
    },
    getRank() {
      const url = "/market/lottery/getRanking";
      let params;
      const that = this;
      if (this.cur == "0") {
        params = {
          shopId: this.shopId
        };
      } else {
        params = {
          shopId: this.shopId,
          startTime: moment(this.startTime).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.endTime).format('YYYY-MM-DD HH:mm:ss')
        };
        console.log(params)
      }
      queryPost(url, params)
        .then(res => {
          if (res.data.code == "0000") {
            let result = res.data.data.results;
            that.myMarket = result.userRanking;
            that.first = result.ranking[0];
            if (that.first.userName.length > 5) {
              that.first.userName = that.first.userName.slice(0, 5) + '...'
            }
            that.second = result.ranking[1];
            if (that.second.userName.length > 5) {
              that.second.userName = that.second.userName.slice(0, 5) + '...'
            }
            that.third = result.ranking[2];
            if (that.third.userName.length > 5) {
              that.third.userName = that.third.userName.slice(0, 5) + '...'
            }
            result.ranking.splice(0, 3);
            that.rankList = result.ranking;
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.msg
            }).then(() => {
            });
          }
        })
        .catch(() => {
          // Dialog.alert({
          //   title: '提示',
          //   message: '您还未登录，请登录',
          // }).then(() => {
          //   window.history.back(-1);
          // })
        });
    },
    getTime() {
      let weekOfDay = moment().format("E"); // 指定日期的周的第几天

      let lastMonday = moment()
        .subtract(weekOfDay - 1, "days")
        .format("YYYY/MM/DD"); //周一日期
      let lastSunday = moment()
        .add(7 - weekOfDay, "days")
        .format("YYYY/MM/DD"); //周日日期
      this.startTime = lastMonday;
      this.endTime = lastSunday;
    },
    toFixed(number, decimals, dec_point, thousands_sep) {
      number = (number + "").replace(/[^0-9+-Ee.]/g, "");
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return "" + Math.ceil(n * k) / k;
        };
      s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
      var re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }
      if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
      }
      return s.join(dec);
    },
    moment(time) {
      if (time == undefined) {
        return moment();
      }
      return moment(time);
    }
  }
};
</script>

<style lang="less" scoped>
.sale_ranking {
  width: 100%;
  min-height: 100vh;
  background: url("https://imgs.youchalian.com/1638499916633.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
}

.sale_ranking .tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}

.sale_ranking .tab .tab-item-title {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  transition: font-size 0.1s linear;
}

.sale_ranking .tab .tab-item-title.tab-current {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  transition: font-size 0.1s linear;
}

.sale_ranking .tab-cursor {
  width: 48px;
  height: 4px;
  background: #be2c0f;
  border-radius: 2px;
  display: inline-block;
  left: 112px;
  position: relative;
  transition: left 0.1s linear;
  margin-top: 5px;
}

.ranking-container {
  flex: 1;
  padding: 14px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.ranking-container .ranking-date {
  padding: 3px 10px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 14px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}

.ranking-container .ranking-tip {
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}

.ranking-container .podium {
  width: 100%;
  margin-top: 21px;
  height: 210px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: url("https://imgs.youchalian.com/1638500248195.png") no-repeat;
  background-size: 100% 100px;
  background-position: 0 100%;
  padding: 0 auto;
}

.ranking-container .podium .second-rank {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 61px;
}

.ranking-container .podium .first-rank {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 61px;
}

.ranking-container .podium .third-rank {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 61px;
}

.ranking-container .podium .second-rank .second-head {
  width: 71px;
  height: 75px;
  background: url("https://imgs.youchalian.com/1638495954580.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 3px 3px 0;
  box-sizing: border-box;
  display: flex;
  margin-top: 29px;
}

.ranking-container .podium .first-rank .first-head {
  width: 71px;
  height: 75px;
  background: url("https://imgs.youchalian.com/1638499997765.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 3px 3px 0;
  box-sizing: border-box;
  display: flex;
}

.ranking-container .podium .third-rank .third-head {
  width: 71px;
  height: 75px;
  background: url("https://imgs.youchalian.com/1638500132677.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 3px 3px 0;
  box-sizing: border-box;
  display: flex;
  margin-top: 41px;
}

.head-img {
  display: block;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  margin: auto 0 0 auto;
}
.top-name {
  width: 100%;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 6px;
  text-align: center;
}
.top-rank {
  width: 100%;
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #783717;
  box-sizing: border-box;
}
.top-price {
  width: 100%;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 4px;
}
.sale_ranking .my-info {
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
}

.sale_ranking .my-info .my-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.sale_ranking .my-info .my-rank {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 2px;
}
.sale_ranking .my-info .my-disparity {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 2px;
}
.sale_ranking .my-info .my-sale {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-left: auto;
}
.sale_ranking .rank-list {
  background: #ffffff;
  border-radius: 6px;
  width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  overflow: auto;
}
.sale_ranking .rank-list .rank-item {
  padding: 16px 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sale_ranking .rank-list .rank-item .rank-item-rank {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.sale_ranking .rank-list .rank-item .rank-item-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-left: 12px;
}
.sale_ranking .rank-list .rank-item .rank-item-sale {
  margin-left: auto;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f86e4a;
}
.sale_ranking .rank-list .rank-divider {
  width: 100%;
  height: 1px;
  background: #efefef;
}
</style>
